import { connect } from 'react-redux';
import { selectIsFetching } from 'src/store/popup/selectors';
import { ProcessingOverlay } from './ProcessingOverlay';

const mapStateToProps = (state) => ({
  showPopup: selectIsFetching(state),
});

export default connect(mapStateToProps)(ProcessingOverlay);
